/** Format monaid description text for {@html} display. */
export function formatMonaidDescription(text: string): string {
  return text
    .replace(/\r\n|\r|\n/g, '<br/>')
    .replace(/\*([^*]+)\*/g, '<i>$1</i>')
}

/** True if text contains hiragana, katakana, or CJK ideographs. */
export function containsJapanese(text: string): boolean {
  return /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF\u3400-\u4DBF]/.test(text)
}
